import { createCRUDHook } from './createCRUDHook';
import { OrderLoadingInstructionDto } from 'utils/models/orderLoadingInstruction';
import { TBL_ORDER_LOADING_INSTRUCTION } from './apiEndPoints';

const { Context, useManager, useConsumer } =
  createCRUDHook<OrderLoadingInstructionDto>({
    entityName: 'customerOrderLoadingInstruction',
    endpoint: TBL_ORDER_LOADING_INSTRUCTION,
  });

export const CustomerOrderLoadingInstructionContext = Context;
export const useCustomerOrderLoadingInstructionManager = useManager;
export const useCustomerOrderLoadingInstruction = useConsumer;
